// extracted by mini-css-extract-plugin
export default {"vulnSummary":"vVzj6Sx6KVK03OVbcGw5"};